import React from 'react';
import { isPropStream } from 'utils/brand';
import css from './style.scss';
import propstreamAccountLogo from
  'assets/images/account-page/propstreamlogo-account.svg';

const AccountLogo = () => {
  if (!isPropStream()) return null;

  return (
    <span className={css.reviewLogoWrapper}>
      <img
        src={propstreamAccountLogo}
        alt="PropStream Logo"
        className={css.reviewLogo}
      />
    </span>
  );
};

export default AccountLogo;